
/**
 * 미디어 유형
 */
export type GetStreamingInfoByPath200MediaInfoType = typeof GetStreamingInfoByPath200MediaInfoType[keyof typeof GetStreamingInfoByPath200MediaInfoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetStreamingInfoByPath200MediaInfoType = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  GIF: 'GIF',
  AUDIO: 'AUDIO',
  LINK: 'LINK',
} as const;
